import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../../core/common';

import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import { FormikActions, FormikProps } from 'formik';
import { SurveyQuestionType } from '../../../../models/enums/SurveyQuestionType';
import { Modal } from 'reactstrap';
import Header from './questionTypes/header';
import Choice from './questionTypes/choice';
import Paragraph from './questionTypes/paragraph';
import Matrix from './questionTypes/matrix';
import { IQuestionList } from '../../../../models/components/add-activity-survey-questions';
import { IResponseData } from '../../../../models/components/activity-card-survey';
import { Guid } from 'guid-typescript';
import OpenEnded from './questionTypes/openended';
import { ISurveyInfo } from '../../../../models/action/survey';

const _logger = Log.create('Survey Card');
const T = Translator.create();
let _common: Common;

interface ISurveyQuestionsModalProps {
    isModalOpen: boolean;
    isPreview: boolean;
    triggerModal: () => void;
    formik: FormikProps<IResponseData>;
    onSubmit: (values: IResponseData, formikActions: FormikActions<IResponseData>) => void;
    isSubmitting: boolean;
    questionList?: any;
    surveyName?: string;
    isShowOnStartUp?: boolean;
}

class SurveyQuestionsModal extends React.Component<ISurveyQuestionsModalProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    returnQuestions = (question: IQuestionList) => {
        let child;
        if (question) {
            switch (question.questionType) {
                case SurveyQuestionType.Heading:
                    child = (
                        <React.Fragment key={question.surveyQuestionId}>
                            <div className="row">
                                <Header formik={this.props.formik} question={question} />
                            </div>
                            <hr className="dotted" />
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.Paragraph:
                    child = (
                        <React.Fragment key={question.surveyQuestionId}>
                            <div className="row">
                                <Paragraph formik={this.props.formik} question={question} />
                            </div>
                            <hr className="dotted" />
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.OpenEndedTextArea:
                case SurveyQuestionType.OpenEndedOneLine:
                    child = (
                        <div className="row" key={question.surveyQuestionId}>
                                <OpenEnded key={Guid.create().toString()} formik={this.props.formik} question={question} isCard={true} />
                            </div>
                    );
                    break;
                case SurveyQuestionType.Matrix:
                    child = (
                        <React.Fragment key={question.surveyQuestionId}>
                            <div className="row">
                                <Matrix key={Guid.create().toString()} formik={this.props.formik} question={question} />
                            </div>
                            <hr className="dotted" />
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.MultipleChoice:
                    child = (
                        <React.Fragment key={question.surveyQuestionId}>
                            <div className="row">
                                <Choice key={Guid.create().toString()} formik={this.props.formik} isMulti={true} question={question} />
                            </div>
                            <hr className="dotted" />
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.SingleChoice:
                    child = (
                        <React.Fragment key={question.surveyQuestionId}>
                            <div className="row">
                                <Choice key={Guid.create().toString()} formik={this.props.formik} isMulti={false} question={question} />
                            </div>
                            <hr className="dotted" />
                        </React.Fragment>
                    );
                    break;
                default:
                    break;
            }
        }

        return child;
    }

    public render() {
        return (
            <Modal
                id="survey-popup"
                keyboard={false}
                isOpen={this.props.isModalOpen}
                toggle={this.props.isShowOnStartUp ? undefined : this.props.triggerModal}
                contentClassName={'modal-dialog  survey-modal-dialog'}
                modalClassName={''}
            >
                <div className="modal-header border-0 d-flex justify-content-between ">
                    <h6 className='modal-title d-inline-flex'> {this.props.surveyName} </h6>
                    {this.props.isShowOnStartUp ?
                        null
                        : <button onClick={this.props.triggerModal} type="button" style={{ border: 'none', background: 'transparent', fontSize: '1.5em' }} aria-label="Close"><span aria-hidden="true">×</span></button>}
                </div>
                <div className="modal-content ">
                    <div className="modal-body p-0">
                        <div className="row" style={{ marginTop: 0 }}>
                            <div className="col-12">
                                <div className="survey-details" style={{ borderRadius: '16px !important' }}>
                                    {this.props.questionList ? (
                                        this.props.questionList.sort((a: any, b: any) => a.displayOrder - b.displayOrder).map((q: any) => (
                                            this.returnQuestions(q)
                                        ))
                                    ) : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        !this.props.isPreview ? (
                            <div className="modal-footer">
                                <div className="row">
                                    <div className="col text-md-right ml-auto">
                                        <button type="button" disabled={this.props.isSubmitting} onClick={this.props.onSubmit.bind(this, this.props.formik.values, this.props.formik)} className="btn btn-green">
                                            {T.t('r_survey_complete')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : ''
                    }
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISurveyQuestionsModalProps): ISurveyQuestionsModalProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISurveyQuestionsModalProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CSurveyQuestionsModal = connect(mapStateToProps, dispatchProps)(SurveyQuestionsModal);

export default CSurveyQuestionsModal;
